import React from "react";
import "./styles.scss";
import img from "../../assets/images/Vector.svg";
import TotalCard from "../../assets/images/totalCard.svg";
import del from "../../assets/images/Test.svg";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Snackbar } from "@material-ui/core";
import { Alert } from "react-bootstrap";
import Closeicon from "../../assets/images/SheetClose.svg";

function CardSelectedTest(props) {
  const history = useHistory();
  const selected_test = useSelector(
    (state) => state.selected_test.selected_test
  );
  // console.log(uuidpartner, "selected_test");
  const [open, setOpen] = React.useState(false);

  let uuidpartner = props.recPartnerUuid;
  console.log(props, "selected_test");
  const [data, setData] = React.useState({
    data: [],
    homeservice: "yes",
    recommended_test: {},
  });

  React.useEffect(() => {
    if (selected_test && selected_test.length !== 0) {
      let res = [];
      let recommended_test_uuid = [];
      let patientName = "";
      let patientId = "";

      selected_test.map((v, i) => {
        if (v.patient_uuid) {
          recommended_test_uuid.push(v.doc.testname_uuid);
          patientName = v.patient_name;
          patientId = v.patient_uuid;
        }

        v && v.doc && v.doc.testname_uuid && v.doc.testname_uuid !== undefined
          ? res.push({
              test_type:
                v.doc.testname_uuid.slice(0, 2) === "LP"
                  ? "pathology"
                  : v.doc.testname_uuid.slice(0, 2) === "LR"
                  ? "radiology"
                  : v.doc.testname_uuid === undefined
                  ? "biochecks"
                  : "nodata",
              testname_uuid: v.doc.testname_uuid,
              areaRef: v.doc.areaRef,
            })
          : res.push({
              test_type: "biochecks",
              uuid: v.doc.uuid,
            });
      });

      let dataToSend = {
        data: res,
        homeservice: "yes",
        recommended_test: {
          test_uuid: recommended_test_uuid,
          patient_name: patientName,
          patient_uuid: patientId,
        },
        uuidpartner: { uuidpartner }
      };
      setData(dataToSend);
    }
  }, [selected_test]);

  const handleValidation = () => {
    if (selected_test.length !== 0 && props.area.length !== 0) {
      return true;
    } else {
      console.log(false);
      return false;
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="CardSelectedTest">
        <div className="mobheader">
        <img src={Closeicon} onClick={() => props.onClose(false)} />
          <div>Selected Tests</div>
         
        </div>
        {selected_test.length === 0 ? (
          <>
            <img className="SelectedTestImg" src={TotalCard} alt="icon" />
            <div className="Card_txt">You don’t have any test selected yet</div>
          </>
        ) : (
          selected_test.map((val, i) => (
            <div className="selectedCard" key={i} scroll="yes">
              {val && val.standardisedtestname !== undefined
                ? val.standardisedtestname
                : val && val.doc && val.doc.standardisedtestname !== undefined
                ? val.doc.standardisedtestname
                : val.doc.paneltestname}
              {val && val.standardisedtestname !== undefined ? (
                <img
                  src={del}
                  alt="icon"
                  style={{ cursor: "pointer" }}
                  onClick={() => props.del(val)}
                />
              ) : val &&
                val.doc &&
                val.doc.standardisedtestname !== undefined ? (
                <img
                  src={del}
                  alt="icon"
                  style={{ cursor: "pointer" }}
                  onClick={() => props.del(val)}
                />
              ) : (
                <img
                  src={del}
                  alt="icon"
                  style={{ cursor: "pointer" }}
                  onClick={() => props.del(val)}
                />
              )}
              {/* {val && val.doc &&
              val.doc.standardisedtestname &&
              val.doc.standardisedtestname.length !== 0
                ?<img
                src={del}
                alt="icon"
                style={{ cursor: "pointer" }}
                onClick={() => props.del(val)}
              />
                : <img
                src={del}
                alt="icon"
                style={{ cursor: "pointer" }}
                onClick={() => props.featuredel(val)}
              />} */}
            </div>
          ))
        )}

        {handleValidation() ? (
          <>
            {props.type === "landing" && (
              <div
                className="shoptestsbutton"
                onClick={() =>
                  history.push({ pathname: "/populartest", state: data })
                }
                // style={{ cursor: "pointer" }}
                //         className="shoptestsbutton"
                //         onClick={() => history.push("/populartest")}
              >
                Select More Test
              </div>
            )}
            <div
              className="ComparePrices"
              onClick={() =>
                history.push({ pathname: "/compareprice", state: data })
              }
            >
              Compare Prices
            </div>
          </>
        ) : (
          <div
            className="ComparePrices"
            style={{ cursor: "not-allowed", opacity: "0.5" }}
            onClick={() => setOpen(true)}
          >
            Compare Prices
          </div>
        )}
        <div style={{ height: 32 }}></div>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert severity="error">
          {selected_test.length === 0
            ? "please select the test!"
            : "please select the location!"}
        </Alert>
      </Snackbar>
    </>
  );
}

export default CardSelectedTest;
